module.exports = __webpack_public_path__ + "img/cyberdefence-24.4d6c23d9.svg";